export enum NotificationType {
  TASK = 'task',
  COMMENT = 'comment',
  ORDER = 'order'
}
